<div class="bg-white container text-dark">
  <h1 class='rounded text-center mt-2' *ngIf="!hideFilters"> Education Analytical Report</h1>

  <!-- Show/Hide Filters Button -->
  <div class="row mb-2" *ngIf="!hideFilters">
    <div class="col-12 text-end">
      <button mat-raised-button color="primary" (click)="toggleFilters()">
        <mat-icon>{{ showFilters ? 'filter_list_off' : 'filter_list' }}</mat-icon>
        {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
      </button>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="row" *ngIf="showFilters && !hideFilters">

      <mat-form-field appearance="outline" class="col-md-3 mt-2" >
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker" >
          <input matStartDate placeholder="Start date" [(ngModel)]="startDate">
          <input matEndDate placeholder="End date" [(ngModel)]="endDate">
        </mat-date-range-input>
        <mat-hint>dd/MM/yyyy – dd/MM/yyyy</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3 mt-2">
      <mat-label>Select Centre</mat-label>
      <mat-select [(ngModel)]="selectedCentre"  #selectElemen (selectionChange)="onCentreSelect($event)">
        <mat-option  value="All">All Centres</mat-option>
        <mat-option *ngFor=" let c of (centres$|async)"
                    [value]="c.centreCode">{{c.centreName}} </mat-option>
        <!--      -->
      </mat-select>
    </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-3 col-sm-12 mt-2">
        <mat-label>Select Child</mat-label>
        <mat-select (selectionChange)="onChildSelect($event)">
          <mat-option  value="All">All Child</mat-option>
          <mat-option *ngFor="let c of mChildren" [value]="c">{{c.firstName}} {{c.lastName}}</mat-option>
        </mat-select>
      </mat-form-field>


    <mat-form-field appearance="outline" class="col-md-3 mt-2">
      <mat-label>Gender</mat-label>
      <mat-select [(ngModel)]="selectedGender">
        <mat-option  value="All">All</mat-option>
        <mat-option value="Female">Female</mat-option>
        <mat-option value="Male">Male</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3 mt-2">
      <mat-label>Session Type</mat-label>
      <mat-select [(ngModel)]="sessionType">
        <mat-option  value="All">All Sessions</mat-option>
        <mat-option value="Baseline Assessment">Baseline Assessment</mat-option>
        <mat-option value="Discharge Assessment">Discharge Assessment</mat-option>
        <mat-option value="Intermediate Assessment">Intermediate Assessment</mat-option>
        <mat-option value="Rapport Building">Rapport Building</mat-option>
        <mat-option value="Regular Study">Regular Study</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3 col-sm-12" >
      <mat-label>Subject</mat-label>
      <mat-select [(ngModel)]="selectedSubject" aria-label="Default select example"  >
        <mat-option  value="All">All Subjects</mat-option>
        <mat-option value="Activity">Activity</mat-option>
        <mat-option value="EVS/GK">EVS/GK</mat-option>
        <mat-option value="Language">Language</mat-option>
        <mat-option value="Math">Maths</mat-option>
<!--        <mat-option value="NA">NA</mat-option>-->
      </mat-select>

    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3 col-sm-12" >
      <mat-label>Select Present/Absent</mat-label>
      <mat-select [(ngModel)]="selectedAttendace" aria-label="Default select example"  >
        <mat-option  value="All">All</mat-option>
        <mat-option value="Absent">Absent</mat-option>
        <mat-option value="Present">Present</mat-option>
      </mat-select>

    </mat-form-field>

    <div class="col-md-3">
    <button  class="" mat-mini-fab color="primary" (click)="getData()"><mat-icon>search</mat-icon></button>&nbsp;

        <button  class="me-2" mat-mini-fab color="accent" (click)="Clear()">
          <mat-icon>clear</mat-icon>
        </button>

      <button
        mat-mini-fab color="accent"
        (click)="downloadExcel()">
        <mat-icon>download</mat-icon>
      </button>
    </div>
  </div>

  <div class="row">
    <div *ngIf="educationData.length>1 && educationData" class="col-md-6" style="background-color: #f8d7da;">
      <app-apex-bar-graph title="Gender Graph" [mLabels]="genderLables" [mCount]="genderArray"></app-apex-bar-graph>
    </div>
    <div *ngIf="educationData.length>1 && educationData" class="col-md-6" style="background-color: #d4edda;">
      <app-apex-bar-graph2 title="Subject Graph" [mLabels]="subjectLables" [mCount]="subjectCount"></app-apex-bar-graph2>
    </div>
    <div *ngIf="educationData.length>1 && educationData" class="col-md-6" style="background-color: #cce5ff;">
      <app-apex-bar-graph3 title="Session Graph" [mLabels]="shortLables" [mCount]="sessionCountArray"></app-apex-bar-graph3>
    </div>
    <div *ngIf="educationData.length>1 && educationData" class="col-md-6" style="background-color: #e8f5e9;">
      <app-apex-bar-graph title="Attendance (Present / Absent)" [mLabels]="attendanceLabels" [mCount]="attendanceCountArray"></app-apex-bar-graph>
    </div>
  </div>

  <!-- Group Session Graphs -->
  <div class="row mt-3" *ngIf="groupSessionData.length > 0">
    <div class="col-12 mb-2">
      <h5 class="text-center fw-bold">Group Sessions</h5>
    </div>
    <div class="col-md-6" style="background-color: #fff3cd;">
      <app-apex-bar-graph3 title="Group Session Type" [mLabels]="groupSessionTypeLables" [mCount]="groupSessionCountArray"></app-apex-bar-graph3>
    </div>
    <div class="col-md-6" style="background-color: #e2d9f3;">
      <app-apex-bar-graph2 title="Group Subject Graph" [mLabels]="groupSessionSubjectLables" [mCount]="groupSubjectCountArray"></app-apex-bar-graph2>
    </div>
    <div class="col-12 text-center mb-2">
      <small class="text-muted">Total Group Sessions: <strong>{{ groupSessionData.length }}</strong></small>
    </div>
  </div>

  <div class="table-container mt-4" *ngIf="!hideTable">
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Centre Name, Child Name, Gender etc." #input>
    </mat-form-field>
    <table mat-table [dataSource]="dataSource" style="width: 100%" matSort class="body">
      <ng-container matColumnDef="centre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Centre Name</th>
        <td mat-cell *matCellDef="let element">{{ element.centreName }}</td>
      </ng-container>

      <ng-container matColumnDef="childName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Child Name</th>
        <td mat-cell *matCellDef="let element">{{ element.childName }}</td>
      </ng-container>

      <ng-container matColumnDef="gender">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Gender</th>
        <td mat-cell *matCellDef="let element">{{ element.gender }}</td>
      </ng-container>

      <ng-container matColumnDef="sessionType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Type</th>
        <td mat-cell *matCellDef="let element">{{ element.sessionType }}</td>
      </ng-container>

      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Subject</th>
        <td mat-cell *matCellDef="let element">{{ element.subject }}</td>
      </ng-container>

      <ng-container matColumnDef="presentAbsent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Attendance</th>
        <td mat-cell *matCellDef="let element"> {{getPresent(element)}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 500]" showFirstLastButtons></mat-paginator>
  </div>

</div>
